import React, { forwardRef, useImperativeHandle, useState } from 'react';
import PropTypes from 'prop-types';
import {
  useNotifications,
  NOTIFICATION_STATUSES,
} from '@adsk/alloy-react-notification';
import { useLocale } from '@adsk/alloy-react-helpers';
import useRemoveProjectCompany from './hooks/useRemoveProjectCompany';
import RemoveProjectCompanyModal from './component';

const RemoveProjectCompanyContainer = forwardRef((props, ref) => {
  const { showNotification } = useNotifications();
  const [data, setData] = useState({
    companyId: '',
    companyName: '',
    members: 0,
    projectId: '',
    projectName: '',
  });

  const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));

  const handleSuccess = () => {
    showNotification({
      status: NOTIFICATION_STATUSES.INFO,
      message: T.translate('REMOVING_NOTIFICATION'),
      autoDismiss: 5,
    });

    props.onClose();
    props.onSuccess();
  };

  const handleError = () => {
    showNotification({
      status: NOTIFICATION_STATUSES.ERROR,
      message: T.translate('ERROR_NOTIFICATION', {
        companyName: data.companyName,
      }),
      autoDismiss: 5,
    });
  };

  const { isRemovingCompany, removeProjectCompanyRequest } =
    useRemoveProjectCompany({
      onSuccess: handleSuccess,
      onError: handleError,
      companyId: data.companyId,
      projectId: data.projectId,
    });

  useImperativeHandle(ref, () => ({
    setDataToRemoveCompanyModal(companyAndProjectData) {
      setData(companyAndProjectData);
    },
  }));

  return (
    <RemoveProjectCompanyModal
      data-testid="RemoveProjectCompanyModal__ModalConfirmation"
      companyName={data.companyName}
      isOnConfirmInProgress={isRemovingCompany}
      onClose={props.onClose}
      onRemoveCompany={removeProjectCompanyRequest}
      projectName={data.projectName}
      members={data.members}
      show={props.show}
    />
  );
});

RemoveProjectCompanyContainer.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

export default RemoveProjectCompanyContainer;
